// extracted by mini-css-extract-plugin
export default {"service-item":"Services_service-item__jCNN9","icon":"Services_icon__51eBO","sep":"Services_sep__Q2ndQ"};